module.exports = __webpack_public_path__ + "static/media/opensans-italic-webfont.33de3716.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-italic-webfont.woff
// module id = 1020
// module chunks = 0